export default __webpack_public_path__ + "static/media/money.1b897436.svg";